var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLifetimeCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9ff",
    d: "M66 57.163v1.18a4.82 4.82 0 0 1-4.82 4.82H6.82A4.82 4.82 0 0 1 2 58.343v-1.18a1 1 0 0 1 1-1h62a1 1 0 0 1 1 1z",
    opacity: 1,
    "data-original": "#e9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f5d99",
    d: "M43.56 56.163v1.3c0 .99-.79 1.78-1.78 1.78H26.22c-.98 0-1.78-.79-1.78-1.78v-1.3zM62.64 20.788v35.375H5.36V20.788a4 4 0 0 1 4-4h49.28a4 4 0 0 1 4 4z",
    opacity: 1,
    "data-original": "#4f5d99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70c1f9",
    d: "M58.24 23.183v32.98H9.76v-32.98c0-1.1.9-2 2-2h44.48c1.1 0 2 .9 2 2z",
    opacity: 1,
    "data-original": "#70c1f9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M44.397 56.163h-20.46l-11.76-34.98h20.45zM52.747 56.163h-4.38l-11.77-34.98h4.39z",
    opacity: 1,
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fdc72e",
    d: "M28.576 6.578v41.026c0 .958-.783 1.741-1.74 1.741h-8.932a1.746 1.746 0 0 1-1.74-1.74V6.577c0-.958.782-1.741 1.74-1.741h8.931c.958 0 1.741.783 1.741 1.74z",
    opacity: 1,
    "data-original": "#fdc72e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9ff",
    d: "M16.163 11.186h12.413v4.715H16.163zM16.163 38.281h12.413v4.715H16.163z",
    opacity: 1,
    "data-original": "#e9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed524e",
    d: "M40.98 6.578v41.026a1.74 1.74 0 0 1-1.74 1.741h-8.914a1.74 1.74 0 0 1-1.741-1.74V6.577a1.74 1.74 0 0 1 1.74-1.741h8.915a1.74 1.74 0 0 1 1.74 1.74z",
    opacity: 1,
    "data-original": "#ed524e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9ff",
    d: "M28.576 11.186h12.413v4.715H28.576zM28.576 38.281h12.413v4.715H28.576z",
    opacity: 1,
    "data-original": "#e9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74c579",
    d: "M51.837 11.917v35.905c0 .838-.678 1.523-1.524 1.523h-7.801a1.523 1.523 0 0 1-1.524-1.523V11.917c0-.838.678-1.524 1.524-1.524h7.801c.846 0 1.524.686 1.524 1.524z",
    opacity: 1,
    "data-original": "#74c579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9ff",
    d: "M40.986 16.027h10.847v3.493H40.986zM40.986 40.23h10.847v3.482H40.986zM26.699 22.86v.574a.49.49 0 0 1-.495.495h-7.668a.49.49 0 0 1-.495-.495v-.575a.49.49 0 0 1 .495-.495h7.668a.49.49 0 0 1 .495.495zM26.699 30.748v.575a.49.49 0 0 1-.495.495h-7.668a.49.49 0 0 1-.495-.495v-.575a.49.49 0 0 1 .495-.495h7.668a.49.49 0 0 1 .495.495zM26.699 26.804v.574a.49.49 0 0 1-.495.496h-1.515a.49.49 0 0 1-.495-.496v-.574a.49.49 0 0 1 .495-.496h1.515a.49.49 0 0 1 .495.496zM23.421 26.804v.574a.49.49 0 0 1-.495.496h-4.39a.49.49 0 0 1-.495-.496v-.574a.49.49 0 0 1 .495-.496h4.39a.49.49 0 0 1 .495.496zM39.112 22.86v.574a.49.49 0 0 1-.495.495h-7.668a.49.49 0 0 1-.495-.495v-.575a.49.49 0 0 1 .495-.495h7.668a.49.49 0 0 1 .495.495zM39.112 30.748v.575a.49.49 0 0 1-.495.495h-7.668a.49.49 0 0 1-.495-.495v-.575a.49.49 0 0 1 .495-.495h7.668a.49.49 0 0 1 .495.495zM39.112 26.804v.574a.49.49 0 0 1-.495.496h-1.514a.49.49 0 0 1-.496-.496v-.574a.49.49 0 0 1 .496-.496h1.514a.49.49 0 0 1 .495.496zM35.835 26.804v.574a.49.49 0 0 1-.496.496h-4.39a.49.49 0 0 1-.495-.496v-.574a.49.49 0 0 1 .495-.496h4.39a.49.49 0 0 1 .496.496zM50.201 26.166v.503a.43.43 0 0 1-.433.433h-6.71a.43.43 0 0 1-.434-.433v-.503a.43.43 0 0 1 .433-.434h6.71a.43.43 0 0 1 .434.434zM50.201 33.07v.503a.43.43 0 0 1-.433.433h-6.71a.43.43 0 0 1-.434-.433v-.503a.43.43 0 0 1 .433-.434h6.71a.43.43 0 0 1 .434.434zM50.201 29.618v.503a.43.43 0 0 1-.433.433h-1.325a.43.43 0 0 1-.434-.433v-.503a.43.43 0 0 1 .434-.434h1.325a.43.43 0 0 1 .433.434zM47.333 29.618v.503a.43.43 0 0 1-.433.433h-3.843a.43.43 0 0 1-.433-.433v-.503a.43.43 0 0 1 .433-.434H46.9a.43.43 0 0 1 .433.434z",
    opacity: 1,
    "data-original": "#e9e9ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetimeCourse);
export default __webpack_public_path__ + "static/media/lifetime-course.c16bf304f1ab24cd305275dc9741787f.svg";
export { ForwardRef as ReactComponent };